import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS} from "immutable";
import Form, {STATUSES, prepareValuesForSubmission, validateForm} from "./OrderTaggingRuleForm";
import {cancelCreateOrderTaggingRule} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";


class CreateOrderTaggingRuleFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const updatedValues = prepareValuesForSubmission(values);

    return this.props.createShippingOrderTaggingRule(updatedValues.toJS())
      .then((response) => {
        if (response.data.createShippingOrderTaggingRule.errors.length <= 0) {
          // Success
          this.handleCancel();
        } else {
          let errors = createValidationErrors(response.data.createShippingOrderTaggingRule.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelCreateOrderTaggingRule();
  }

  render() {
    const initialValues = fromJS({
      title: "",
      accountId: "",
      orderTypes: [],
      skuPattern: "",
      tags: "",
      status: STATUSES.DISABLED,
    });

    return (
      <Form
        {...this.props}
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CREATE_ORDER_TAGGING_RULE = gql`
  mutation createShippingOrderTaggingRule($data: CreateShippingOrderTaggingRuleInput!) {
    createShippingOrderTaggingRule(input: $data) {
      ruleId
      errors { key message }
    }
  }
`;

const withMutation = graphql(CREATE_ORDER_TAGGING_RULE, {
  props: ({ mutate }) => ({
    createShippingOrderTaggingRule: (data) => mutate({
      variables: { data: data }
    })
  })
});

export default connect(null, {cancelCreateOrderTaggingRule})(withMutation(CreateOrderTaggingRuleFormContainer));
